var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlexibilityIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.999,
    height: 13.199,
    viewBox: "0 0 20.999 13.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3166",
    "data-name": "Group 3166",
    transform: "translate(0.501 0.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M19.717.353,20.963,1.6,19.717,2.845",
    transform: "translate(-14.655 -0.353)",
    fill: "none",
    stroke: "#00b5e2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    d: "M53.724,40.8l-1.246-1.246,1.246-1.246",
    transform: "translate(-38.785 -28.307)",
    fill: "none",
    stroke: "#00b5e2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    d: "M14.182,15.082H15.5a5,5,0,0,0,0-10c-2.761,0-4.307,2.353-5,5-.627,2.392-2.239,5-5,5a5,5,0,0,1,0-10H6.817",
    transform: "translate(-0.501 -3.836)",
    fill: "none",
    stroke: "#00b5e2",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexibilityIcon);
export default __webpack_public_path__ + "static/media/FlexibilityIcon.e4718d7b6b3036964b841f72aaf325ce.svg";
export { ForwardRef as ReactComponent };